import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { ProducerService } from '../../../services/producer.service'
import { SsrService } from '../../../services/ssr.service'
import { ProducerItemType } from '../../../types/producer.type'

@Component({
  selector: 'bmcore-best-producers',
  templateUrl: './bmcore-best-producers.component.html',
  styleUrls: ['./bmcore-best-producers.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreBestProducersComponent implements OnInit {
  producers: ProducerItemType[] = []

  constructor(
    private producerService: ProducerService,
    private ssrService: SsrService
  ) {}

  ngOnInit(): void {
    this.ssrService.wait('bmcore-best-producers: producerService.getBestProducers')
    this.producerService.getBestProducers().subscribe(data => {
      this.ssrService.ready('bmcore-best-producers: producerService.getBestProducers')
      this.producers = data.items
    })
  }
}
